import i from "../Components/NcInputField.mjs";
import { C as o } from "./Close-BtO5TPBO.mjs";
import { A as a } from "./ArrowRight-C3BxTDjF.mjs";
import { n as s } from "./_plugin-vue2_normalizer-Bj5bLKV4.mjs";
import { r as c, c as u, d as p, a as r } from "./_l10n-BZu8wI2q.mjs";
const d = {
  name: "UndoVariantIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var f = function() {
  var t = this, e = t._self._c;
  return e("span", t._b({ staticClass: "material-design-icon undo-variant-icon", attrs: { "aria-hidden": t.title ? null : !0, "aria-label": t.title, role: "img" }, on: { click: function(l) {
    return t.$emit("click", l);
  } } }, "span", t.$attrs, !1), [e("svg", { staticClass: "material-design-icon__svg", attrs: { fill: t.fillColor, width: t.size, height: t.size, viewBox: "0 0 24 24" } }, [e("path", { attrs: { d: "M13.5,7A6.5,6.5 0 0,1 20,13.5A6.5,6.5 0 0,1 13.5,20H10V18H13.5C16,18 18,16 18,13.5C18,11 16,9 13.5,9H7.83L10.91,12.09L9.5,13.5L4,8L9.5,2.5L10.92,3.91L7.83,7H13.5M6,18H8V20H6V18Z" } }, [t.title ? e("title", [t._v(t._s(t.title))]) : t._e()])])]);
}, _ = [], m = /* @__PURE__ */ s(
  d,
  f,
  _,
  !1,
  null,
  null,
  null,
  null
);
const g = m.exports;
c(p, u);
const h = new Set(Object.keys(i.props)), v = {
  name: "NcTextField",
  components: {
    NcInputField: i,
    Close: o,
    ArrowRight: a,
    Undo: g
  },
  // Allow forwarding all attributes
  inheritAttrs: !1,
  props: {
    /**
     * Any [NcInputField](#/Components/NcFields?id=ncinputfield) props
     */
    // Not an actual prop but needed to show in vue-styleguidist docs
    // eslint-disable-next-line
    " ": {},
    // Reuse all the props from NcInputField for better typing and documentation
    ...i.props,
    /**
     * The `aria-label` to set on the trailing button
     * If no explicit value is set it will default to the one matching the `trailingButtonIcon`:
     * @default 'Clear text'|'Save changes'|'Undo changes'
     */
    trailingButtonLabel: {
      type: String,
      default: ""
    },
    // Custom props
    /**
     * Specifies which material design icon should be used for the trailing
     * button.
     * @type {'close'|'arrowRight'|'undo'}
     */
    trailingButtonIcon: {
      type: String,
      default: "close",
      validator: (n) => [
        "close",
        "arrowRight",
        "undo"
      ].includes(n)
    }
  },
  emits: [
    "update:value"
  ],
  computed: {
    propsAndAttrsToForward() {
      const n = {
        undo: r("Undo changes"),
        close: r("Clear text"),
        arrowRight: r("Save changes")
      };
      return {
        // Proxy all the HTML attributes
        ...this.$attrs,
        // Proxy original NcInputField's props
        ...Object.fromEntries(
          Object.entries(this.$props).filter(([t]) => h.has(t))
        ),
        // Adjust aria-label for predefined trailing buttons
        trailingButtonLabel: this.trailingButtonLabel || n[this.trailingButtonIcon]
      };
    }
  },
  methods: {
    /**
     * Focus the input element
     *
     * @public
     */
    focus() {
      this.$refs.inputField.focus();
    },
    /**
     * Select all the text in the input
     *
     * @public
     */
    select() {
      this.$refs.inputField.select();
    },
    handleInput(n) {
      this.$emit("update:value", n.target.value);
    }
  }
};
var F = function() {
  var t = this, e = t._self._c;
  return e("NcInputField", t._g(t._b({ ref: "inputField", on: { input: t.handleInput }, scopedSlots: t._u([t.type !== "search" ? { key: "trailing-button-icon", fn: function() {
    return [t.trailingButtonIcon === "close" ? e("Close", { attrs: { size: 20 } }) : t.trailingButtonIcon === "arrowRight" ? e("ArrowRight", { attrs: { size: 20 } }) : t.trailingButtonIcon === "undo" ? e("Undo", { attrs: { size: 20 } }) : t._e()];
  }, proxy: !0 } : null], null, !0) }, "NcInputField", t.propsAndAttrsToForward, !1), t.$listeners), [t._t("default")], 2);
}, b = [], C = /* @__PURE__ */ s(
  v,
  F,
  b,
  !1,
  null,
  null,
  null,
  null
);
const y = C.exports;
export {
  y as N
};
